  <div class="d-flex">
    <ng-template [ngIf]="isLoading">
      <app-loading [contesto]="'COMPLETA_FASE3'"></app-loading>
  </ng-template>
    <form [formGroup]="completaPraticaForm">
      <div class="grid formgrid p-fluid mt-2">
        <div class="field mt-2 mb-2 col-6">
          <label for="ordineEsecuzione" class="font-medium text-900">Ordine di Esecuzione</label>
          <input type="text" formControlName="ordineEsecuzione" pInputText>
        </div>
        <div class="field mt-2 mb-2 col-6">
          <label for="nomePerInvio" class="font-medium text-900">Codice invio</label>
          <input type="text" formControlName="nomePerInvio" pInputText>
        </div>
        <div class="field mt-2 mb-2 col-12">
          <label for="fileComputoMetrico" class="font-medium text-900">Carica il <B>COMPUTO METRICO</B></label>
          <p-fileUpload name="fileComputoMetrico" 
              multiple="false"
              maxFileSize="15000000"
              chooseLabel="Cerca" uploadLabel="Carica" cancelLabel="Cancella"
              [auto]="true"
              [customUpload]="true"
              (uploadHandler)="onComputoMetricoUpload($event)"
              [showUploadButton]="false"
              [showCancelButton]="false"
              (onRemove)="onComputoMetricoRemove()"
              [disabled]="isComputoMetricoUploaded "
              class="custom-red-button"
          >
          </p-fileUpload>
        </div>
      </div>

    </form>
  
  </div>
  <h1 class="m-0 mb-1 mt-1 text-center text-900 font-semibold text-xl line-height-3">
    <span *ngIf="isTipoD">
      La conferma scatenerà la generazione dei VEBALI DI CESSIONE DEI DIRITTI SUBIRU e di CESSIONE PROPRIETA' NUOVE INFRASTRUTTURE.
    </span>
    <span *ngIf="!isTipoD">
      La conferma scatenerà la generazione del VERBALE DI CESSIONE DIRITTI IRU
    </span>
  </h1>
  <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

  <div>
    <div style="display: flex; justify-content: center; gap: 10px;">
    <p-button [disabled]="!completaPraticaForm.valid" icon="pi pi-check" label="Conferma" class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)"></p-button>
    <p-button icon="pi pi-times" label="Annulla" class="p-button-text" styleClass="p-button-warning" (click)="conferma(false)"></p-button> 
  </div>

</div>
